/**
 * AP-28 Nachtrag N-19 — **die EAN, eine Regel für Maske, Server und Import.**
 *
 * Erlaubt sind die GTIN-Längen, die auf Ware tatsächlich stehen: GTIN-8
 * (EAN-8), GTIN-12 (UPC-A), GTIN-13 (EAN-13) und GTIN-14 (Umverpackung).
 * Geprüft wird die **Prüfziffer** (Modulo 10, Gewichte 3/1 von rechts) — ein
 * Zahlendreher fällt beim Tippen auf und nicht erst beim Scannen an der Kasse.
 */

export const EAN_LENGTHS = [8, 12, 13, 14] as const

/** Leerzeichen und Bindestriche fallen weg — „90 12345 678903" ist dieselbe Nummer. */
export function normalisiereEan(text: string): string {
  return text.replace(/[\s-]/g, '')
}

/** Ziffern in erlaubter Länge mit passender Prüfziffer. Erwartet die normalisierte Form. */
export function istGueltigeEan(text: string): boolean {
  if (!/^\d+$/.test(text) || !(EAN_LENGTHS as readonly number[]).includes(text.length)) return false
  const ziffern = text.split('').map(Number)
  const pruefziffer = ziffern.pop()!
  const summe = ziffern.reverse().reduce((s, z, i) => s + z * (i % 2 === 0 ? 3 : 1), 0)
  return (10 - (summe % 10)) % 10 === pruefziffer
}
